export default "assets/chevron-d9a6543e.svg";